import {Component, CUSTOM_ELEMENTS_SCHEMA, Input, OnInit} from '@angular/core';
import {PropertyCardComponent} from '../../common/property-card/property-card.component';

@Component({
  selector: 'app-property-units',
  templateUrl: './property-units.component.html',
  styleUrls: ['../property-page.component.scss','./property-units.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    PropertyCardComponent
  ]
})
export class PropertyUnitsComponent  implements OnInit {

  @Input() units: any;
  @Input() parentId: string = '';
  @Input() parentName: string = '';
  constructor() { }

  ngOnInit() {
  }

}
